/**
 * Segmentos de una ruta de categoría/subcategoría sin el prefijo `/entradas`:
 * `[genre, location, style?]` (p. ej. `/entradas/conciertos/madrid/pop/`).
 */
function categorySegments(path: string): string[] {
  const segments = path.split('/').filter(Boolean)
  return segments[0] === 'entradas' ? segments.slice(1) : segments
}

/**
 * Indica si `pathname` (la página en la que se abre el menú) corresponde al
 * `href` de una categoría o subcategoría del drawer. La localización se ignora
 * (el menú se construye con la de la cookie, la página puede ser otra) y el
 * `style` solo se compara si el `href` lo tiene: una categoría (`/conciertos/
 * todos`) está activa en toda su rama, una subcategoría (`/conciertos/todos/
 * pop`) solo en la suya. Un tercer segmento numérico (paginación) no casa con
 * ninguna subcategoría, pero sí mantiene activa la categoría.
 */
export function isNavHrefCurrent(pathname: string, href: string): boolean {
  const [pathGenre, , pathStyle] = categorySegments(pathname)
  const [hrefGenre, , hrefStyle] = categorySegments(href)
  if (!pathGenre || pathGenre !== hrefGenre) return false
  return hrefStyle === undefined || hrefStyle === pathStyle
}
